import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-nowrap mt-1 ml-4",
  style: {"font-size":"13px"}
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ValidationErrors',
  props: {
    messages: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'v-input--error': __props.messages?.length })
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (__props.messages && __props.messages.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.messages, (message, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "text-error"
            }, _toDisplayString(message), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})